// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"j_s","tags__list":"j_G"};